import { tokenizeQuery } from 'api/search'
import { escapeRegExp } from 'lodash'
import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { Masked, MaskedText } from 'shared/components/MaskedText'
import { getEnableDataMaskingPreference } from 'store/user/selectors'

export interface IHighlightSearchTextProps {
  text?: string
  highlight?: string
}

export const HighlightSearchText: React.FC<IHighlightSearchTextProps> = memo(
  ({ text, highlight }) => {
    const textTrimmed = (text || '').trim()
    const highlightTrimmed = (highlight || '').trim()
    if (!highlightTrimmed) {
      return <span>{textTrimmed}</span>
    }
    const regex = new RegExp(
      `(${tokenizeQuery(highlightTrimmed).map(escapeRegExp).join('|')})`,
      'i'
    )
    const parts = textTrimmed.split(regex)
    return (
      <span>
        {parts
          .filter((part) => part)
          .map((part, i) =>
            regex.test(part) ? (
              <mark className="highlight" style={{ fontWeight: 700 }} key={i}>
                {part}
              </mark>
            ) : (
              <span key={i}>{part}</span>
            )
          )}
      </span>
    )
  }
)

export const ConnectedMaskedHighlight: React.FC<IHighlightSearchTextProps> = (
  props
) => {
  const shouldMask = useSelector(getEnableDataMaskingPreference)
  return shouldMask ? (
    <MaskedText text={props.text} />
  ) : (
    <HighlightSearchText {...props} />
  )
}

export const ConnectedMaskedHighlightPlain: React.FC<
  IHighlightSearchTextProps
> = (props) => {
  const shouldMask = useSelector(getEnableDataMaskingPreference)
  return shouldMask ? (
    <Masked text={props.text} />
  ) : (
    <HighlightSearchText {...props} />
  )
}
